export const Countries = {
  'zh-CN': _TL_('China - Simplified Chinese'),
  'en-AR': _TL_('Argentina - English'),
  'en-MG': _TL_('Madagascar - English'),
  'en-TW': _TL_('Taiwan - English'),
  'en-MR': _TL_('Mauritania - English'),
  'en-HK': _TL_('Hong Kong - English'),
  'en-US': _TL_('United States - English'),
  'en-GB': _TL_('United Kingdom - English'),
  'fr-FR': _TL_('France - French'),
  'de-DE': _TL_('Germany - German'),
  'nl-NL': _TL_('Netherlands - Dutch'),
  'es-ES': _TL_('Spain - Spanish'),
  'it-IT': _TL_('Italy - Italian'),
  'de-CH': _TL_('Switzerland - German'),
  'de-AT': _TL_('Austria - German'),
  'sv-SE': _TL_('Sweden - Swedish'),
  'fr-BE': _TL_('Belgium - French'),
  'en-CA': _TL_('Canada - English'),
  'en-AU': _TL_('Australia - English'),
  'en-IN': _TL_('India - English'),
  'ja-JP': _TL_('Japan - Japanese'),
  'da-DK': _TL_('Denmark - Danish'),
  'fi-FI': _TL_('Finland - Finnish'),
  'en-IE': _TL_('Ireland - English'),
  'nb-NO': _TL_('Norway - Norwegian'),
  'pl-PL': _TL_('Poland - Polish'),
  'pt-PT': _TL_('Portugal - Portuguese'),
  'tr-TR': _TL_('Turkey - Turkish'),
  'el-GR': _TL_('Greece - Greek'),
  'en-ZA': _TL_('South Africa - English'),
  'fr-AD': _TL_('Andorra - French'),
  'bg-BG': _TL_('Bulgaria - Bulgarian'),
  'en-CY': _TL_('Cyprus - English'),
  'el-CY': _TL_('Cyprus - Greek'),
  'cs-CZ': _TL_('Czech Republic - Czech'),
  'et-EE': _TL_('Estonia - Estonian'),
  'en-GR': _TL_('Greece - English'),
  'hr-HR': _TL_('Croatia - Croatian'),
  'en-HU': _TL_('Hungary - English'),
  'hu-HU': _TL_('Hungary - Hungarian'),
  'de-LI': _TL_('Liechtenstein - German'),
  'lt-LT': _TL_('Lithuania - Lithuanian'),
  'fr-LU': _TL_('Luxembourg - French'),
  'de-LU': _TL_('Luxembourg - German'),
  'lv-LV': _TL_('Latvia - Latvian'),
  'fr-MC': _TL_('Monaco - French'),
  'mt-MT': _TL_('Malta - Maltese'),
  'ro-RO': _TL_('Romania - Romanian'),
  'sk-SK': _TL_('Slovakia - Slovak'),
  'en-SK': _TL_('Slovakia - English'),
  'sl-SI': _TL_('Slovenia - Slovenian'),
  'it-SM': _TL_('San Marino - Italian'),
  'en-SM': _TL_('San Marino - English'),
  'it-VA': _TL_('Vatican - Italian'),
  'sr-RS': _TL_('Serbia - Serbian'),
  'bs-BA': _TL_('Bosnia And Herzegovina - Bosnian'),
  'sq-AL': _TL_('Albania - Albanian'),
  'mk-MK': _TL_('Republic of North Macedonia - Macedonian'),
  'is-IS': _TL_('Iceland - Icelandic'),
  'sr-ME': _TL_('Montenegro - Serbian'),
  'en-AD': _TL_('Andorra-English'),
  'en-AL': _TL_('Albania-English'),
  'en-AT': _TL_('Austria-English'),
  'en-BA': _TL_('Bosnia and Herzegovina-English'),
  'en-BE': _TL_('Belgium-English'),
  'en-BG': _TL_('Bulgaria-English'),
  'en-CH': _TL_('Switzerland-English'),
  'en-CZ': _TL_('Czech Republic-English'),
  'en-DE': _TL_('Germany-English'),
  'en-DK': _TL_('Denmark-English'),
  'en-EE': _TL_('Estonia-English'),
  'en-ES': _TL_('Spain-English'),
  'en-FI': _TL_('Finland-English'),
  'en-FR': _TL_('France-English'),
  'en-HR': _TL_('Croatia-English'),
  'en-IS': _TL_('Iceland-English'),
  'en-IT': _TL_('Italy-English'),
  'en-LI': _TL_('Liechtenstein-English'),
  'en-LT': _TL_('Lithuania-English'),
  'en-LU': _TL_('Luxembourg-English'),
  'en-LV': _TL_('Latvia-English'),
  'en-MC': _TL_('Monaco-English'),
  'en-ME': _TL_('Montenegro-English'),
  'en-MK': _TL_('Republic of North Macedonia-English'),
  'en-MT': _TL_('Malta-English'),
  'en-NL': _TL_('Netherlands-English'),
  'en-NO': _TL_('Norway-English'),
  'en-PL': _TL_('Poland-English'),
  'en-PT': _TL_('Portugal-English'),
  'en-RO': _TL_('Romania-English'),
  'en-RS': _TL_('Serbia-English'),
  'en-SE': _TL_('Sweden-English'),
  'en-SI': _TL_('Slovenia-English'),
  'en-TR': _TL_('Turkey-English'),
  'en-VA': _TL_('Vatican-English'),
  'de-ES': _TL_('Spain-German'),
  'de-FR': _TL_('France-German'),
  'de-GB': _TL_('United Kingdom-German'),
  'de-IT': _TL_('Italy-German'),
  'de-NL': _TL_('Netherlands-German'),
  'de-PL': _TL_('Poland-German'),
  'es-DE': _TL_('Germany-Spanish'),
  'es-FR': _TL_('France-Spanish'),
  'es-GB': _TL_('United Kingdom-Spanish'),
  'es-IT': _TL_('Italy-Spanish'),
  'es-PT': _TL_('Portugal-Spanish'),
  'et-DE': _TL_('Germany-Estonian'),
  'et-FR': _TL_('France-Estonian'),
  'et-GB': _TL_('United Kingdom-Estonian'),
  'et-IT': _TL_('Italy-Estonian'),
  'fr-CH': _TL_('Switzerland-French'),
  'fr-DE': _TL_('Germany-French'),
  'fr-ES': _TL_('Spain-French'),
  'fr-GB': _TL_('United Kingdom-French'),
  'fr-IT': _TL_('Italy-French'),
  'it-DE': _TL_('Germany-Italian'),
  'it-ES': _TL_('Spain-Italian'),
  'it-FR': _TL_('France-Italian'),
  'it-GB': _TL_('United Kingdom-Italian'),
  'lv-DE': _TL_('Germany-Latvian'),
  'lv-FR': _TL_('France-Latvian'),
  'nl-AT': _TL_('Austria-Dutch'),
  'nl-BE': _TL_('Belgium-Dutch'),
  'nl-CH': _TL_('Switzerland-Dutch'),
  'nl-DE': _TL_('Germany-Dutch'),
  'nl-ES': _TL_('Spain-Dutch'),
  'nl-FR': _TL_('France-Dutch'),
  'nl-GB': _TL_('United Kingdom-Dutch'),
  'nl-IT': _TL_('Italy-Dutch'),
  'nl-PL': _TL_('Poland-Dutch'),
  'nl-SE': _TL_('Sweden-Dutch'),
  // 'no-NO': _TL_-(''), Waiting to confirm 'no' language
  'pt-ES': _TL_('Spain-Portuguese'),
  'pt-FR': _TL_('France-Portuguese'),
  'sv-DE': _TL_('Germany-Swedish'),
  'en-ID': _TL_('Indonesia-English'),
  'en-MY': _TL_('Malaysia-English'),
  'en-NZ': _TL_('New Zealand-English'),
  'en-PH': _TL_('Philippines-English'),
  'en-SG': _TL_('Singapore-English'),
  'en-TH': _TL_('Thailand-English'),
  'en-VN': _TL_('Vietnam-English'),
  'es-AR': _TL_('Argentina-Spanish'),
  'pt-BR': _TL_('Brazil-Portuguese'),
  'es-CL': _TL_('Chile-Spanish'),
  'es-CO': _TL_('Colombia-Spanish'),
  'es-MX': _TL_('Mexico-Spanish'),
  'es-PE': _TL_('Peru-Spanish'),
  'es-VE': _TL_('Venezuela-Spanish'),
  'zh-TW': _TL_('Taiwan-Traditional Chinese'),
  'zh-HK': _TL_('Hong kong-Traditional Chinese'),
  'en-AW': _TL_('Aruba-English'),
  'en-BS': _TL_('Bahamas-English'),
  'es-BO': _TL_('Bolivia-Spanish'),
  'en-KY': _TL_('Cayman Islands-English'),
  'es-CR': _TL_('Costa Rica-Spanish'),
  'en-DM': _TL_('Dominica-English'),
  'es-DO': _TL_('Dominican Republic-Spanish'),
  'es-EC': _TL_('Ecuador-Spanish'),
  'es-SV': _TL_('El Salvador-Spanish'),
  'fr-GF': _TL_('French Guiana-French'),
  'es-GT': _TL_('Guatemala-Spanish'),
  'en-GY': _TL_('Guyana-English'),
  'fr-HT': _TL_('Haiti-French'),
  'es-HN': _TL_('Honduras-Spanish'),
  'fr-MQ': _TL_('Martinique-French'),
  'en-MS': _TL_('Montserrat-English'),
  'es-PA': _TL_('Panama-Spanish'),
  'es-PY': _TL_('Paraguay-Spanish'),
  'es-PR': _TL_('Puerto Rico-Spanish'),
  'en-TT': _TL_('Trinidad and Tobago-English'),
  'es-UY': _TL_('Uruguay-Spanish'),
  'en-BD': _TL_('Bangladesh-English'),
  'en-BN': _TL_('Brunei-English'),
  'en-FJ': _TL_('Fiji-English'),
  'fr-PF': _TL_('French Polynesia-French'),
  'en-GU': _TL_('Guam-English'),
  'en-MV': _TL_('Maldives-English'),
  'en-MN': _TL_('Mongolia-English'),
  'en-NP': _TL_('Nepal-English'),
  'fr-NC': _TL_('New Caledonia-French'),
  'en-PG': _TL_('Papua New Guinea-English'),
  'en-LK': _TL_('Sri Lanka-English'),
  'fr-CD': _TL_('Democratic Republic of the Congo-French'),
  'en-ET': _TL_('Ethiopia-English'),
  'fr-GN': _TL_('Guinea-French'),
  'en-LS': _TL_('Lesotho-English'),
  'fr-MG': _TL_('Madagascar-French'),
  'en-MW': _TL_('Malawi-English'),
  'fr-MR': _TL_('Mauritania-French'),
  'en-MU': _TL_('Mauritius-English'),
  'en-NA': _TL_('Namibia-English'),
  'en-NG': _TL_('Nigeria-English'),
  'fr-RE': _TL_('Reunion-French'),
  'en-SC': _TL_('Seychelles-English'),
  'en-TZ': _TL_('Tanzania-English'),
  'en-GM': _TL_('The Gambia-English'),
  'fr-TG': _TL_('Togo-French'),
  'en-ZW': _TL_('Zimbabwe-English'),
  'fr-DZ': _TL_('Algeria-French'),
  'en-AM': _TL_('Armenia-English'),
  'en-AZ': _TL_('Azerbaijan-English'),
  'en-BH': _TL_('Bahrain-English'),
  'en-EG': _TL_('Egypt-English'),
  'en-GE': _TL_('Georgia-English'),
  'en-IQ': _TL_('Iraq-English'),
  'he-IL': _TL_('Israel-Hebrew'),
  'en-KG': _TL_('Kyrgyzstan-English'),
  'en-LY': _TL_('Libya-English'),
  'en-MD': _TL_('Moldova-English'),
  'en-OM': _TL_('Oman-English'),
  'en-PK': _TL_('Pakistan-English'),
  'en-QA': _TL_('Qatar-English'),
  'en-TJ': _TL_('Tajikistan-English'),
  'en-AE': _TL_('United Arab Emirates-English'),
  'ar-YE': _TL_('Yemen-Arabic'),
  'ar-SA': _TL_('Saudi Arabia-Arabic'),
  'ru-KG': _TL_('Kyrgyzstan-Russian'),
  'es-US': _TL_('United States-Spanish'),
  'fr-CA': _TL_('Canada-French'),
  'en-CL': _TL_('Chile-English'),
  'en-TG': _TL_('Togo-English'),
  'en-YE': _TL_('Yemen-English'),
  'en-PF': _TL_('French Polynesia-English'),
  'en-HN': _TL_('Honduras-English'),
  'en-JP': _TL_('Japan-English'),
  'en-CD': _TL_('Democratic Republic of the Congo-English'),
  'en-SV': _TL_('El Salvador-English'),
  'en-BO': _TL_('Bolivia-English'),
  'en-VE': _TL_('Venezuela-English'),
  'en-PR': _TL_('Puerto Rico-English'),
  'en-IL': _TL_('Israel-English'),
  'en-NC': _TL_('New Caledonia-English'),
  'en-GN': _TL_('Guinea-English'),
  'en-CO': _TL_('Colombia-English'),
  'en-PE': _TL_('Peru-English'),
  'en-PY': _TL_('Paraguay-English'),
  'en-MQ': _TL_('Martinique-English'),
  'en-SA': _TL_('Saudi Arabia-English'),
  'en-PA': _TL_('Panama-English'),
  'en-HT': _TL_('Haiti-English'),
  'en-BR': _TL_('Brazil-English'),
  'fr-CM': _TL_('Cameroon-French'),
  'fr-CG': _TL_('Republic of Congo-French'),
  'fr-CI': _TL_('Cote d\'Ivoire-French'),
  'en-RW': _TL_('Rwanda-English'),
  'fr-SN': _TL_('Senegal-French'),
  'en-SO': _TL_('Somalia-English'),
  'en-UG': _TL_('Uganda-English'),
  'en-ZM': _TL_('Zambia-English'),
  'en-BW': _TL_('Botswana-English'),
  'fr-GA': _TL_('Gabon-French'),
  'fr-TN': _TL_('Tunisia-French'),
  'fr-BJ': _TL_('Benin-French'),
  'fr-BF': _TL_('Burkina Faso-French'),
  'fr-NE': _TL_('Niger-French'),
  'en-AS': _TL_('American Samoa-English'),
  'en-AI': _TL_('Anguilla-English'),
  'en-BM': _TL_('Bermuda-English'),
  'en-VG': _TL_('British Virgin Islands-English'),
  'en-GI': _TL_('Gibraltar-English'),
  'en-MP': _TL_('Northern Mariana Islands-English'),
  'en-TC': _TL_('Turks and Caicos Islands-English'),
  'en-VI': _TL_('United States Virgin Islands-English'),
  'en-BB': _TL_('Barbados-English'),
  'en-BZ': _TL_('Belize-English'),
  'en-GD': _TL_('Grenada-English'),
  'en-JM': _TL_('Jamaica-English'),
  'en-MH': _TL_('Marshall Islands-English'),
  'en-KN': _TL_('Saint Kitts and Nevis-English'),
  'en-LC': _TL_('Saint Lucia-English'),
  'en-VC': _TL_('Saint Vincent and the Grenadines-English'),
  'en-SR': _TL_('Suriname-English'),
  'en-TO': _TL_('Tonga-English'),
  'en-GL': _TL_('Greenland-English'),
  'en-FO': _TL_('Faroe Islands-English'),
  'en-AG': _TL_('Antigua and Barbuda-English'),
  'en-CC': _TL_('Cocos (Keeling) Islands-English'),
  'en-CF': _TL_('Central African Republic-English'),
  'fr-CF': _TL_('Central African Republic-French'),
  'en-CK': _TL_('Cook Islands-English'),
  'en-CX': _TL_('Christmas Island-English'),
  'ar-DJ': _TL_('Djibouti-Arabic'),
  'en-DJ': _TL_('Djibouti-English'),
  'fr-DJ': _TL_('Djibouti-French'),
  'en-ER': _TL_('Eritrea-English'),
  'en-GW': _TL_('Guinea-Bissau-English'),
  'pt-GW': _TL_('Guinea-Bissau-Portuguese'),
  'ar-KM': _TL_('Comoros-Arabic'),
  'fr-KM': _TL_('Comoros-French'),
  'en-NF': _TL_('Norfolk Island-English'),
  'en-NR': _TL_('Nauru-English'),
  'en-NU': _TL_('Niue-English'),
  'fr-PM': _TL_('Saint Pierre and Miquelon-French'),
  'en-PN': _TL_('Pitcairn Islands-English'),
  'en-PW': _TL_('Palau-English'),
  'en-SL': _TL_('Sierra Leone-English'),
  'en-TK': _TL_('Tokelau-English'),
  'en-TV': _TL_('Tuvalu-English'),
  'en-VU': _TL_('Vanuatu-English'),
  'fr-WF': _TL_('Wallis and Futuna-French'),
  'en-WS': _TL_('Samoa-English'),
  'fr-YT': _TL_('Mayotte-French'),
  'tl-PH': _TL_('Filipino-Phillipines'),
  'hi-IN': _TL_('Hindi-India'),
  'vi-VN': _TL_('Vietnamese-Vietnam'),
  'th-TH': _TL_('Thai-Thailand'),
  'ms-MY': _TL_('Malay-Malaysia'),
  'id-ID': _TL_('Indonesian-Indonesia'),
  'ko-KR': _TL_('Korean-South Korea'),
};

export const CountriesWithoutLanguage = {
  CN: _TL_('China'),
  US: _TL_('United States'),
  GB: _TL_('United Kingdom'),
  FR: _TL_('France'),
  DE: _TL_('Germany'),
  NL: _TL_('Netherlands'),
  ES: _TL_('Spain'),
  IT: _TL_('Italy'),
  CH: _TL_('Switzerland'),
  AT: _TL_('Austria'),
  SE: _TL_('Sweden'),
  BE: _TL_('Belgium'),
  CA: _TL_('Canada'),
  AU: _TL_('Australia'),
  IN: _TL_('India'),
  JP: _TL_('Japan'),
  DK: _TL_('Denmark'),
  FI: _TL_('Finland'),
  IE: _TL_('Ireland'),
  NO: _TL_('Norway'),
  PL: _TL_('Poland'),
  PT: _TL_('Portugal'),
  TR: _TL_('Turkey'),
  GR: _TL_('Greece'),
  ZA: _TL_('South Africa'),
  AD: _TL_('Andorra'),
  BG: _TL_('Bulgaria'),
  CY: _TL_('Cyprus'),
  CZ: _TL_('Czech Republic'),
  EE: _TL_('Estonia'),
  HR: _TL_('Croatia'),
  HU: _TL_('Hungary'),
  LI: _TL_('Liechtenstein'),
  LT: _TL_('Lithuania'),
  LU: _TL_('Luxembourg'),
  LV: _TL_('Latvia'),
  MC: _TL_('Monaco'),
  MT: _TL_('Malta'),
  RO: _TL_('Romania'),
  SK: _TL_('Slovakia'),
  SI: _TL_('Slovenia'),
  SM: _TL_('San Marino'),
  VA: _TL_('Vatican'),
  RS: _TL_('Serbia'),
  BA: _TL_('Bosnia and Herzegovina'),
  AL: _TL_('Albania'),
  MK: _TL_('Republic of North Macedonia'),
  IS: _TL_('Iceland'),
  ME: _TL_('Montenegro'),
  ID: _TL_('Indonesia'),
  MY: _TL_('Malaysia'),
  NZ: _TL_('New Zealand'),
  PH: _TL_('Philippines'),
  SG: _TL_('Singapore'),
  TH: _TL_('Thailand'),
  VN: _TL_('Vietnam'),
  AR: _TL_('Argentina'),
  BR: _TL_('Brazil'),
  CL: _TL_('Chile'),
  CO: _TL_('Colombia'),
  MX: _TL_('Mexico'),
  PE: _TL_('Peru'),
  VE: _TL_('Venezuela'),
  TW: _TL_('Taiwan'),
  HK: _TL_('Hong Kong'),
  AW: _TL_('Aruba'),
  BS: _TL_('Bahamas'),
  BO: _TL_('Bolivia'),
  KY: _TL_('Cayman Islands'),
  CR: _TL_('Costa Rica'),
  DM: _TL_('Dominica'),
  DO: _TL_('Dominican Republic'),
  EC: _TL_('Ecuador'),
  SV: _TL_('El Salvador'),
  GF: _TL_('French Guiana'),
  GT: _TL_('Guatemala'),
  GY: _TL_('Guyana'),
  HT: _TL_('Haiti'),
  HN: _TL_('Honduras'),
  MQ: _TL_('Martinique'),
  MS: _TL_('Montserrat'),
  PA: _TL_('Panama'),
  PY: _TL_('Paraguay'),
  PR: _TL_('Puerto Rico'),
  TT: _TL_('Trinidad and Tobago'),
  UY: _TL_('Uruguay'),
  BD: _TL_('Bangladesh'),
  BN: _TL_('Brunei'),
  FJ: _TL_('Fiji'),
  PF: _TL_('French Polynesia'),
  GU: _TL_('Guam'),
  MV: _TL_('Maldives'),
  MN: _TL_('Mongolia'),
  NP: _TL_('Nepal'),
  NC: _TL_('New Caledonia'),
  PG: _TL_('Papua New Guinea'),
  LK: _TL_('Sri Lanka'),
  CD: _TL_('Democratic Republic of the Congo'),
  ET: _TL_('Ethiopia'),
  GN: _TL_('Guinea'),
  LS: _TL_('Lesotho'),
  MG: _TL_('Madagascar'),
  MW: _TL_('Malawi'),
  MR: _TL_('Mauritania'),
  MU: _TL_('Mauritius'),
  NA: _TL_('Namibia'),
  NG: _TL_('Nigeria'),
  RE: _TL_('Reunion'),
  SC: _TL_('Seychelles'),
  TZ: _TL_('Tanzania'),
  GM: _TL_('The Gambia'),
  TG: _TL_('Togo'),
  ZW: _TL_('Zimbabwe'),
  DZ: _TL_('Algeria'),
  AM: _TL_('Armenia'),
  AZ: _TL_('Azerbaijan'),
  BH: _TL_('Bahrain'),
  EG: _TL_('Egypt'),
  GE: _TL_('Georgia'),
  IQ: _TL_('Iraq'),
  IL: _TL_('Israel'),
  KG: _TL_('Kyrgyzstan'),
  LY: _TL_('Libya'),
  MD: _TL_('Moldova'),
  OM: _TL_('Oman'),
  PK: _TL_('Pakistan'),
  QA: _TL_('Qatar'),
  TJ: _TL_('Tajikistan'),
  AE: _TL_('United Arab Emirates'),
  YE: _TL_('Yemen'),
  SA: _TL_('Saudi Arabia'),
  CM: _TL_('Cameroon'),
  CG: _TL_('Republic of Congo'),
  CI: _TL_('Cote d\'Ivoire'),
  RW: _TL_('Rwanda'),
  SN: _TL_('Senegal'),
  SO: _TL_('Somalia'),
  UG: _TL_('Uganda'),
  ZM: _TL_('Zambia'),
  BW: _TL_('Botswana'),
  GA: _TL_('Gabon'),
  TN: _TL_('Tunisia'),
  BJ: _TL_('Benin'),
  BF: _TL_('Burkina Faso'),
  NE: _TL_('Niger'),
  AS: _TL_('American Samoa'),
  AI: _TL_('Anguilla'),
  BM: _TL_('Bermuda'),
  VG: _TL_('British Virgin Islands'),
  GI: _TL_('Gibraltar'),
  MP: _TL_('Northern Mariana Islands'),
  TC: _TL_('Turks and Caicos Islands'),
  VI: _TL_('United States Virgin Islands'),
  BB: _TL_('Barbados'),
  BZ: _TL_('Belize'),
  GD: _TL_('Grenada'),
  JM: _TL_('Jamaica'),
  MH: _TL_('Marshall Islands'),
  KN: _TL_('Saint Kitts and Nevis'),
  LC: _TL_('Saint Lucia'),
  VC: _TL_('Saint Vincent and the Grenadines'),
  SR: _TL_('Suriname'),
  TO: _TL_('Tonga'),
  GL: _TL_('Greenland'),
  FO: _TL_('Faroe Islands'),
  AG: _TL_('Antigua and Barbuda'),
  CC: _TL_('Cocos (Keeling) Islands'),
  CF: _TL_('Central African Republic'),
  CK: _TL_('Cook Islands'),
  CX: _TL_('Christmas Island'),
  DJ: _TL_('Djibouti'),
  ER: _TL_('Eritrea'),
  GW: _TL_('Guinea-Bissau'),
  KM: _TL_('Comoros'),
  NF: _TL_('Norfolk Island'),
  NR: _TL_('Nauru'),
  NU: _TL_('Niue'),
  PM: _TL_('Saint Pierre and Miquelon'),
  PN: _TL_('Pitcairn Islands'),
  PW: _TL_('Palau'),
  SL: _TL_('Sierra Leone'),
  TK: _TL_('Tokelau'),
  TV: _TL_('Tuvalu'),
  VU: _TL_('Vanuatu'),
  WF: _TL_('Wallis and Futuna'),
  WS: _TL_('Samoa'),
  YT: _TL_('Mayotte'),
  KR: _TL_('South Korea'),
};

export const Languages = {
  zh: _TL_('Chinese'),
  en: _TL_('English'),
  fr: _TL_('French'),
  de: _TL_('German'),
  nl: _TL_('Dutch'),
  es: _TL_('Spanish'),
  it: _TL_('Italian'),
  sv: _TL_('Swedish'),
  ja: _TL_('Japanese'),
  da: _TL_('Danish'),
  fi: _TL_('Finnish'),
  nb: _TL_('Norwegian'),
  pl: _TL_('Polish'),
  pt: _TL_('Portuguese'),
  tr: _TL_('Turkish'),
  el: _TL_('Greek'),
  bg: _TL_('Bulgarian'),
  cs: _TL_('Czech'),
  et: _TL_('Estonian'),
  hr: _TL_('Croatian'),
  hu: _TL_('Hungarian'),
  lv: _TL_('Latvian'),
  lt: _TL_('Lithuanian'),
  mt: _TL_('Maltese'),
  ro: _TL_('Romanian'),
  sk: _TL_('Slovak'),
  sl: _TL_('Slovenian'),
  sr: _TL_('Serbian'),
  bs: _TL_('Bosnian'),
  sq: _TL_('Albanian'),
  mk: _TL_('Macedonian'),
  is: _TL_('Icelandic'),
  ar: _TL_('Arabic'),
  he: _TL_('Hebrew'),
  ru: _TL_('Russian'),
  tl: _TL_('Filipino'),
  hi: _TL_('Hindi'),
  vi: _TL_('Vietnamese'),
  th: _TL_('Thai'),
  ms: _TL_('Malay'),
  id: _TL_('Indonesian'),
  ko: _TL_('Korean'),
};
